import PageTemplate from "04UserPages/00PageTemplate/PageTemplate";
import TabBar from "97Parts/Andon/TabBar";
import { AndonPage } from "./AndonPage";
import LogIDPage from "./LogIDPage";

const UserMainPage = () => {
  const tabLabels: string[] = ["ステータス表示", "ログ表示"];
  const components = [<AndonPage key="andon" />, <LogIDPage key="log" />];

  return (
    <PageTemplate title="">
      <TabBar tabLabels={tabLabels}>{components}</TabBar>
    </PageTemplate>
  );
};

export default UserMainPage;
